export default __webpack_public_path__ + "static/media/surya.a5272780.jpg";